// Campo de e-mail/telefone do onboarding. A verificação de identidade NÃO
// acontece aqui: o onboarding apenas coleta o valor; a verificação real (envio
// de código + validação) roda no gate pós-login, contra endpoints do backend.
// Antes este componente simulava verificação via setTimeout — teatro de
// segurança removido (SEC-010).
import { type ChangeEvent } from "react";

import { Icon, type IconName } from "@/components/common/Icon";
import { Field } from "@/components/onboarding/OnbFields";

export interface VerifyFieldProps {
  label: string;
  channel: "email" | "sms";
  required?: boolean;
  placeholder?: string;
  type?: string;
  icon: IconName;
  inputMode?: "email" | "tel" | "numeric" | "text" | "none" | "url" | "search";
  maxLength?: number;
  value: string;
  onChangeValue: (v: string) => void;
  // Mantidos por compatibilidade com os callers; a verificação real é pós-login.
  isVerified?: boolean;
  onVerified?: () => void;
  hint?: string;
  formatter?: (v: string) => string;
}

export function WsVerifyField({
  label,
  required,
  placeholder,
  type,
  icon,
  inputMode,
  value,
  onChangeValue,
  hint,
  formatter,
  maxLength,
}: VerifyFieldProps) {
  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    onChangeValue(formatter ? formatter(raw) : raw);
  };

  return (
    <Field label={label} required={required} hint={hint}>
      <div className="onb-input-wrap">
        <Icon name={icon} size={14} />
        <input
          className="onb-input bare"
          type={type}
          inputMode={inputMode}
          maxLength={maxLength}
          placeholder={placeholder}
          value={value}
          onChange={onInputChange}
        />
      </div>
    </Field>
  );
}
